import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* global FB */
import React from 'react';
import { attachScript } from '../../../../../common/utils/attach-script';
import AccessibleSocialButton from './accessible-social-button';
const LIBRARY_URL = 'https://connect.facebook.net/en_US/sdk.js';
export default class FacebookButton extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init", containerNode => {
      FB.init({
        xfbml: true,
        version: 'v2.5'
      });
      return new Promise(resolve => {
        FB.XFBML.parse(containerNode, resolve);
      });
    });
  }
  attachScript() {
    if (window.FB) {
      return Promise.resolve();
    }
    return attachScript(LIBRARY_URL);
  }
  render() {
    const {
      cardData,
      isAccessible,
      facebookButtonTitle
    } = this.props;
    return /*#__PURE__*/React.createElement(AccessibleSocialButton, {
      isAccessible: isAccessible,
      attachScript: this.attachScript,
      title: facebookButtonTitle,
      initButton: this.init
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-like",
      "data-href": cardData.url,
      "data-layout": "button",
      "data-action": "like"
    }));
  }
}
//# sourceMappingURL=facebook.js.map